/* eslint import/no-duplicates: "off" */
/* eslint no-return-assign: "off" */

import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import loadable from '@loadable/component'
import config from '../../config'
import GoogleAdSense from '../../helpers/GoogleAdSense'
import { pushEventAndTrack } from '../../helpers/TaggingSerializer'
import { ServiceHelper } from '../../helpers/ServiceHelper'
import GoogleAdSenseFooter from '../GoogleAdSenseFooter/GoogleAdSenseFooter'
import Template from './NoResultsSuggestions.template'
import Logger from '../../utils/Logger'
import * as Styled from './styles'
import { getValue } from '../../utils/ConfigProvider'

const ProductCard = loadable(() =>
  import(/* webpackChunkName: "labs-product-card" */ '../ProductList/StyledProductCard.js')
)
const CMS = loadable.lib(() => import(/* webpackChunkName: "cms-components" */ '@sainsburys-tech/bolt-cms-components'))
const logger = new Logger()

export default class NoResultsSuggestions extends React.Component {
  constructor(props, context) {
    super(props, context)
    const items = []
    const itemsPerSlide = {
      itemsPerSlideXs: 2,
      itemsPerSlideSm: 2,
      itemsPerSlideMd: 3,
      itemsPerSlideLg: 4
    }

    this.state = {
      application: {
        isCannedSearch: true
      },
      bestSellersSliderOptions: {
        ...itemsPerSlide,
        items
      }
    }
  }

  componentDidMount() {
    if (typeof document !== 'undefined' && document.getElementsByClassName('app--search-lister')[0]) {
      pushEventAndTrack({
        eventName: 'errorPage',
        eventAction: '404 Canned Search Event'
      })
      document.getElementsByClassName('app--search-lister')[0].classList.add('canned-search')
    }

    this.setState(state => {
      state.application.isCannedSearch = false
      return state
    })

    if (typeof window !== 'undefined') {
      window.addEventListener(
        'orientationchange',
        () => {
          this.getBestSellersProducts()
        },
        false
      )
    }

    this.getBestSellersProducts()
  }

  componentWillUnmount() {
    if (
      typeof document !== 'undefined' &&
      document.getElementsByClassName('app--search-lister').length > 0 &&
      document.getElementsByClassName('app--search-lister')[0].classList.contains('canned-search')
    ) {
      document.getElementsByClassName('app--search-lister')[0].classList.remove('canned-search')
    }
  }

  getBestSellersProducts() {
    let bestSellersProducts = []
    const self = this
    const contentServiceRequest = ServiceHelper.buildContentServiceRequest({ categoryId: 'all' }, this.context)
    this.context.fetchr.read(contentServiceRequest.service, contentServiceRequest.params, {}, function(
      err,
      contentServiceResponse,
      meta
    ) {
      if (err) {
        logger.error('componentLogger', err, 'Unable to fetch best selling products.')
      } else {
        const resultsSize = contentServiceResponse.response.data.length
        contentServiceResponse.response.data.forEach(product => {
          self.context.fetchr.read('pdp', { partNumbers: product.id }, {}, (err, pdpResponse) => {
            let bestSellersProduct
            if (err || pdpResponse.errors.length > 0) {
              logger.debug('componentLogger', err || pdpResponse.errors, 'Unable to fetch pdp service response.')
              bestSellersProduct = null
            } else {
              bestSellersProduct = pdpResponse.data[0].attributes
              bestSellersProduct.price = pdpResponse.included[0].attributes
              bestSellersProduct.productLink = `/product/${pdpResponse.data[0].id}`
              bestSellersProduct.id = pdpResponse.data[0].id
            }
            bestSellersProducts.push(bestSellersProduct)
            if (bestSellersProducts.length === resultsSize) {
              bestSellersProducts = self.createCarouselArray(bestSellersProducts)
              const newSliderOptions = self.state.bestSellersSliderOptions
              newSliderOptions.items = bestSellersProducts
              self.setState({ bestSellersSliderOptions: newSliderOptions })
            }
          })
        })
      }
    })
  }

  createCarouselArray(products) {
    // Removing cards for products that don't exist anymore
    products = products.filter(function(n) {
      return n != null
    })
    products.forEach((element, index) => {
      products[index] = (
        <ErrorBoundary key={`${index}-${element.id}-boundary`}>
          <div className='xs-12 sm-6 md-4 lg-3'>
            <ProductCard
              key={`sliderProduct-${index}-${element.id}`}
              className='no-results-suggestions__slider-product'
              brand={element.brand}
              name={element.name}
              price={element.price.now}
              specialOfferText={element.price.flashText}
              wasPrice={element.price.was}
              productLink={element.productLink}
              partNumber={element.partNumber}
              cta={<></>}
            />
          </div>
        </ErrorBoundary>
      )
    })
    return products
  }

  handleGoogleAdsense(props) {
    let mount
    const { pageType } = props
    if (GoogleAdSense.isPageTypeValid(pageType) && config.adSense[pageType].enabled) {
      mount = (
        <ErrorBoundary>
          <GoogleAdSenseFooter {...props} />
        </ErrorBoundary>
      )
    }
    return mount
  }

  render() {
    const { searchTerm, categories } = this.props
    const headers =
      searchTerm !== ''
        ? {
            mainHeader: `${Template.searchTermHeaderStart}${searchTerm}${Template.searchTermHeaderEnd}`,
            subheader: Template.searchTermSubheader
          }
        : {
            mainHeader: Template.simpleHeader,
            subheader: Template.simpleSubheader
          }

    return (
      <ErrorBoundary>
        <Styled.Container tabIndex='0' data-el='no-results-suggestions-container'>
          <Styled.Heading data-test='no-results-suggestions-heading'>{headers.mainHeader}</Styled.Heading>
          <Styled.Subheading>{headers.subheader}</Styled.Subheading>

          <ErrorBoundary>
            <CMS>
              {({ components }) => {
                const { M0074 } = components

                return (
                  <Styled.CategoryContainer data-test='no-results-suggestions-category-container'>
                    {categories.map((category, index) => {
                      return (
                        <div
                          className='xs-6 sm-6 md-4 lg-3'
                          data-test='no-results-suggestions-category-tile'
                          key={index}>
                          <M0074
                            backgroundSize='contain'
                            linkTitle={category.attributes.name}
                            linkUrl={category.attributes.url}
                            heading={category.attributes.name}
                            mainImage={`//media.4rgos.it/i/Argos/${category.id}_IMG`}
                            imageStyle='square'
                            type='M0074'
                          />
                        </div>
                      )
                    })}
                  </Styled.CategoryContainer>
                )
              }}
            </CMS>
          </ErrorBoundary>

          {getValue('features.bestSellers.enabled') && (
            <>
              <Styled.Header>{Template.bestSellers}</Styled.Header>
              <ErrorBoundary>
                <Styled.SliderComponent
                  className='no-results-suggestions__slider-product no-results-suggestions__best-sellers-slider'
                  data-test='best-sellers'
                  slideClass='no-results-suggestions__slider-slide'
                  {...this.state.bestSellersSliderOptions}
                />
              </ErrorBoundary>
            </>
          )}
          {this.handleGoogleAdsense({
            pageType: 'search',
            searchTerm: this.context.store.getState().product.searchTerm,
            categoryName: null,
            noResults: true,
            meta: { appliedFilters: [], listerType: 'SEARCH' },
            categoryAncestors: []
          })}
        </Styled.Container>
      </ErrorBoundary>
    )
  }
}

NoResultsSuggestions.contextTypes = {
  store: PropTypes.object,
  fetchr: PropTypes.object
}

NoResultsSuggestions.propTypes = {
  searchTerm: PropTypes.string,
  categories: PropTypes.array
}

NoResultsSuggestions.defaultProps = {
  searchTerm: '',
  categories: []
}
